import { useGetGroupByIdQuery } from '../../group/GroupAPI';
import { toBase64 } from '../../../shared/util/base64';
import { DevicesStoreInfoResponse } from '../StoreService.model';
import { ComposableDevice } from '../../group/group.model';
import { useMemo } from 'react';

export type ComposableDevicesStoreInfoResponse = {
  composableDevice?: ComposableDevice;
} & DevicesStoreInfoResponse;
function useDevicesWithComposableDevice(
  groupId: string,
  list: DevicesStoreInfoResponse[]
): { devices: ComposableDevicesStoreInfoResponse[] } {
  const { data: storeGroup, ...restGroups } = useGetGroupByIdQuery(
    groupId ?? ''
  );

  const devices: ComposableDevicesStoreInfoResponse[] = useMemo(() => {
    const groupChildren = storeGroup?.childGroups ?? [];
    return (
      list.map((device) => {
        const composableDeviceGroup = groupChildren.find(
          (group) => group.id === toBase64(device.composableDeviceId || '')
        );
        return {
          ...device,
          composableDevice: composableDeviceGroup?.composableDevice,
        };
      }) ?? []
    );
  }, [list, storeGroup?.childGroups]);

  return {
    devices,
    ...restGroups,
  };
}

export default useDevicesWithComposableDevice;
